module.exports = __webpack_public_path__ + "static/img/b-icon-4-active.001c592.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/b-icon-4-active.png
// module id = v23t
// module chunks = 0